var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-screen"},[_c('lottie',{staticClass:"animation",attrs:{"animation-data":require('@/assets/images/home/blow_up_loading.json'),"loop":true,"auto-play":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }